import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ArrowRight from '@mui/icons-material/SubdirectoryArrowRight';
import Equipment from './Equipment';

import ListGroup from 'react-bootstrap/ListGroup';

const MarketType = ({ classes, marketType, showTitle, expanded }) => {
  const [open, setOpen] = useState(expanded);

  useEffect(() => {
    if (expanded) {
      setOpen(true);
    }
  }, [expanded]);

  if (showTitle) {
    // This listing should be a collapsible list with the market type header
    // Only show the market type header if there are multiple market types within a subtype
    return (
      <ListGroup.Item 
        className={classNames(classes.clickable)}
        onClick={() => setOpen(!open)}
        style={{ backgroundColor: '#f8f9fa' }}
      >
        <ArrowRight style={{ fontSize: '1.25em' }} />{marketType.name}
        {open ? <ExpandLess style={{ fontSize: '1.25em' }} /> : <ExpandMore style={{ fontSize: '1.25em' }} />}
        <Collapse in={!open} timeout="auto" unmountOnExit>
          <ListGroup>
            {marketType.equipment.map(equipment => (
              <Equipment key={equipment.equipment_id} classes={classes} equipment={equipment} />
            ))}
          </ListGroup>
        </Collapse>
      </ListGroup.Item>
    );
  }

  // Show the list of equipment WITHOUT the market type header
  // This means there is only 1 market type for this subtype
  return (
    <>
      {marketType.equipment.map(equipment => (
        <Equipment key={equipment.equipment_id} classes={classes} equipment={equipment} />
      ))}
    </>
  );
}

export default MarketType;
